import * as ActionTypes from './actionTypes';
import get from 'lodash/get';
import extend from 'lodash/extend';

export const initialState = {
  commissionsDetails: {
    response: {},
    pageNumber: 1,
    isLoading: false,
    isServiceError: false,
    sortByValue: 'policyOrGroupName',
    filters: [],
    filtersQueryString: '',
    searchDetails: {
      searchBy: 'policyOrGroupName',
      value: '',
      isLoading: false,
      options: [],
    },
  },
  commissionsInsight: {
    response: {},
    isLoading: false,
    isServiceError: false,
  },
};

export default function commissionSummaryReducer(state = {}, action) {
  const defaultCD = initialState.commissionsDetails;
  const defaultCI = initialState.commissionsInsight;
  const defaultCDSearchDetails = defaultCD.searchDetails;

  switch (action.type) {
    case ActionTypes.SET_COMMISSION_DETAILS:
      return extend({}, state, action.payload);
    case ActionTypes.SET_COMMISSION_PAGINATION_DETAILS:
      return extend({}, state, action.payload);
    case ActionTypes.COMMISSIONS_DETAILS_INSIGHT:
    case ActionTypes.SET_USERAGENT_DETAILS:
    case ActionTypes.SET_MODAL_CONTENT:
    case ActionTypes.USERAGENT_FETCH_FAILED:
    case ActionTypes.SET_COMMISSION_DETAILS_LOADING:
    case ActionTypes.SET_USERAGENT_DETAILS_LOADING:
    case ActionTypes.SET_USERAGENT_LIST:
      return extend({}, state, action.payload, { showErrors: false });
    case ActionTypes.RESET_COMMISSIONS_DETAILS:
      return {};
    case ActionTypes.COMMISSION_PAGINATION_DETAILS_FETCH_FAILED:
    case ActionTypes.COMMISSIONS_DETAILS_INSIGHT_FAILED:
    case ActionTypes.COMMISSION_DETAILS_FETCH_FAILED:
      return extend({}, state, action.payload, { showErrors: true });
    case ActionTypes.COMMISSIONS_DETAILS_SEARCH:
      return extend({}, state, action.payload);
    case ActionTypes.COMMISSIONS_DETAILS_SEARCH_FAILED:
      return extend({}, state, action.payload, { showErrors: true });

    // new action types
    case ActionTypes.SET_COMMISSIONS_REST_PROPS:
      return {
        ...state,
        commissions: {
          ...get(state.commissions, {}),
          ...action.details,
          sort: { ...get(state.commissions, 'sort', {}), ...action.details.sort },
        },
      };

    case ActionTypes.COMMISSIONS_DETAILS_INSIGHT_SERVICE_ERROR:
      return {
        ...state,
        commissionsInsight: {
          ...get(state, 'commissionsInsight', defaultCI),
          isLoading: false,
          isServiceError: true,
        },
      };

    case ActionTypes.REQUEST_COMMISSIONS_DETAILS_INSIGHT:
      return {
        ...state,
        commissionsInsight: {
          ...get(state, 'commissionsInsight', defaultCI),
          isLoading: true,
          isServiceError: false,
        },
      };

    case ActionTypes.RECEIVE_COMMISSIONS_DETAILS_INSIGHT:
      return {
        ...state,
        commissionsInsight: {
          ...get(state, 'commissionsInsight', defaultCI),
          isLoading: false,
          isServiceError: false,
          response: action.response,
        },
      };

    case ActionTypes.COMMISSIONS_DETAILS_SERVICE_ERROR:
      return {
        ...state,
        commissionsDetails: {
          ...get(state, 'commissionsDetails', defaultCD),
          isLoading: false,
          isServiceError: true,
        },
      };

    case ActionTypes.REQUEST_COMMISSIONS_DETAILS:
      return {
        ...state,
        commissionsDetails: {
          ...get(state, 'commissionsDetails', defaultCD),
          isLoading: true,
          isServiceError: false,
        },
      };

    case ActionTypes.RECEIVE_COMMISSIONS_DETAILS:
      return {
        ...state,
        commissionsDetails: {
          ...get(state, 'commissionsDetails', defaultCD),
          isLoading: false,
          isServiceError: false,
          response: action.response,
        },
      };

    case ActionTypes.SET_COMMISSIONS_DETAILS_PAGE_NUMBER:
      return {
        ...state,
        commissionsDetails: {
          ...get(state, 'commissionsDetails', defaultCD),
          pageNumber: action.pageNumber,
        },
      };

    case ActionTypes.CONCAT_COMMISSIONS_DETAILS:
      return {
        ...state,
        commissionsDetails: {
          ...get(state, 'commissionsDetails', defaultCD),
          isLoading: false,
          isServiceError: false,
          pageNumber: action.pageNumber,
          response: {
            ...action.response,
            data: [...get(state, 'commissionsDetails.response.data', []), ...action.response.data],
          },
        },
      };

    case ActionTypes.SET_COMMISSIONS_DETAILS_REST_PROPS:
      return {
        ...state,
        commissionsDetails: {
          ...get(state, 'commissionsDetails', defaultCD),
          ...action.details,
        },
      };

    case ActionTypes.SET_COMMISSIONS_DETAILS_SEARCH_DETAILS:
      return {
        ...state,
        commissionsDetails: {
          ...get(state, 'commissionsDetails', defaultCD),
          searchDetails: {
            ...get(state, 'commissionsDetails.searchDetails', defaultCDSearchDetails),
            ...action.details,
          },
        },
      };

    default:
      return state;
  }
}
